import type { Nullable, ProductKind } from '@iheartjane/types';
import { ProductKindEnum } from '@iheartjane/types';

import type { AlgoliaFacets, FilterSelectItem } from '@jane/search/types';
import type { Store } from '@jane/shared/types';

import { customSubcategoryLabel } from '../customSubcategoryLabel/customSubcategoryLabel';

type Subcategories = Partial<Record<ProductKind, FilterSelectItem[]>>;

export const getSubcategories = (
  facets: AlgoliaFacets,
  store: Store,
  mainCategory?: Nullable<ProductKind>
) => {
  const rootTypes = facets.root_types ?? {};

  return Object.entries(rootTypes).reduce<Subcategories>(
    (acc, [rootType, count]) => {
      const [category, subcategory] = rootType.split(':');

      if (
        ProductKindEnum.includes(category as ProductKind) &&
        subcategory &&
        (!mainCategory || category === mainCategory)
      ) {
        acc[category as ProductKind] ??= [];
        acc[category as ProductKind]?.push({
          count,
          label: customSubcategoryLabel({
            store,
            subcategory: { value: rootType, label: subcategory },
          }),
          value: rootType,
        });
      }

      return acc;
    },
    {}
  );
};
